/**
 * Shared styling for record pages (W12 U2). Links read as text until hovered:
 * the underline-everything look of the POC made every name compete.
 */
export const RECORD_LINK =
  "font-medium text-foreground underline-offset-4 hover:underline";

/** Secondary text next to a link (role, stage, "at …"). */
export const MUTED = "text-muted-foreground";

/** "Willow Woodley" -> "WW"; "Agents with a Grin" -> "AG". */
export function initials(name: string | null | undefined): string {
  const words = String(name ?? "")
    .split(/\s+/)
    .filter((w) => /^[\p{L}\p{N}]/u.test(w));
  const letters =
    words.length > 1 ? [words[0], words[words.length - 1]] : words;
  return (
    letters
      .map((w) => w[0]!.toUpperCase())
      .join("")
      .slice(0, 2) || "?"
  );
}

/** A role id inside a sentence: "co_borrower" -> "co borrower". */
export function roleText(id: string | null | undefined): string {
  return String(id ?? "").replace(/_/g, " ");
}

/** "real_estate_agent" -> "Real estate agent". */
export function humanize(id: string | null | undefined): string {
  const text = String(id ?? "").replace(/_/g, " ");
  return text.charAt(0).toUpperCase() + text.slice(1);
}
